/* eslint-disable */

import React, { useEffect, useState } from "react";
import { fetchOrganisationsTransferGet } from "../../../services/api-raindrop.js";
import Spacer from "../../../ui-components/spacer/spacer.js";
import Currency from "../../../ui-components/currency/currency.tsx";
import DateFormat from "../../../ui-components/date-format/date-format.tsx";
import RaindropDivider from "../../../ui-components/raindrop-divider/raindrop-divider.js";
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";

const OrganisationTransfer = ({
  id,
  subunits,
  subunitsCurrency,
  transferredAt,
  rawData,
  isSelected = false,
}) => {
  let backgroundColor = "bg-transparent";

  if (isSelected) {
    backgroundColor = "bg-color-dark-background-secondary";
  }

  return (
    <Link to={`/cirrus/donations/${id}`}>
      <div
        className={`flex flex-row gap-4 items-center w-full max-w-lg p-4 rounded-lg transition-all hover:bg-color-dark-background-tertiary hover:cursor-pointer ${backgroundColor}`}
      >
        <div className="flex flex-col flex-nowrap whitespace-nowrap">
          <h1 className="text-sm text-color-dark-text-secondary">
            Transfer for
          </h1>
          <DateFormat dateIsoString={transferredAt} />
        </div>
        <Spacer />

        <Currency
          subunits={subunits}
          currency={subunitsCurrency}
          isStylised={true}
        />

        <i className="fas fa-chevron-right" />
      </div>
    </Link>
  );
};

const CirrusDonations = ({ organisation, currentOrganisationUser }) => {
  const { organisationTransferId } = useParams();

  console.log(organisationTransferId, "RD-3332");

  const [organisationTransfers, setOrganisationTransfers] = useState(null);

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);

    fetchOrganisationsTransferGet({
      organisationId: organisation.id,
    })
      .then((response) => {
        setOrganisationTransfers(response);
        console.log(response, "RD-3332");
      })
      .finally(() => setIsLoading(false));
  }, []);

  return (
    <div className={`flex flex-col w-full h-full `}>
      <div id="sidebar" className="flex flex-col gap-6 max-w-md ">
        <h1 className="font-bold text-4xl">Your donations</h1>
        <RaindropDivider />

        {organisationTransfers && organisationTransfers.length === 0 && (
          <div>
            Your organisation's donations will appear here after people start
            donating.
          </div>
        )}

        <div>
          {organisationTransfers &&
            organisationTransfers.map((organisationTransfer) => {
              return (
                <OrganisationTransfer
                  key={organisationTransfer.id}
                  rawData={organisationTransfer}
                  id={organisationTransfer.id}
                  subunits={organisationTransfer.subunits}
                  subunitsCurrency={organisationTransfer.subunits_currency}
                  transferredAt={organisationTransfer.transferred_at}
                  isSelected={
                    organisationTransfer.id === organisationTransferId
                  }
                />
              );
            })}
        </div>
      </div>
    </div>
  );
};

export default CirrusDonations;
